import { useRecoilState, useRecoilValue } from "recoil";
import Fade from "../../components/Fade";
import ListItem from "../../components/ListItem";
import { selectionAtom } from "../../store/selection.atom";
import { titles } from "../../store/title.atome";

const AllCategories = ({ disableAnimation }: { disableAnimation: boolean }) => {
  const [selection, setSelection] = useRecoilState(selectionAtom);
  const { news } = useRecoilValue(titles);

  return (
    <div
      className={`custom-scroll max-h-[calc(100dvh-103px-64.8px)] overflow-y-scroll border-rss-border bg-white md:max-h-[calc(100dvh-103px-69px)] md:flex-shrink-0 md:border-r-[1px]`}
    >
      <Fade
        isVisible={
          (selection.category === undefined && selection.blog === undefined) ||
          disableAnimation
        }
      >
        <ul className={`flex flex-col md:w-80`}>
          {news.map((cat) => (
            <ListItem
              key={cat.id}
              onClick={() =>
                setSelection({
                  category: cat,
                  blog: undefined,
                })
              }
              className={
                selection.category?.id === cat.id
                  ? "!from-[#F3E9FF] !to-white"
                  : ""
              }
            >
              {cat.title}
            </ListItem>
          ))}
        </ul>
      </Fade>
    </div>
  );
};

export default AllCategories;
